(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["topbar"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function setup(topbar) {
      if (!topbar) return;

      // Tear down any existing timers (e.g. when re-initialising in the editor)
      (topbar.__rotators || []).forEach(function (r) { clearInterval(r.timer); });
      topbar.__rotators = [];

      var enabled = topbar.getAttribute('data-rotate-text') === 'true';
      var interval = parseInt(topbar.getAttribute('data-rotate-interval'), 10) || 3000;

      topbar.querySelectorAll('.topbar__column').forEach(function (col) {
        var texts = Array.prototype.slice.call(col.children).filter(function (c) {
          return c.classList && c.classList.contains('topbar__text');
        });

        col.classList.remove('is-rotating');
        texts.forEach(function (t) { t.classList.remove('is-active'); });

        // Nothing to rotate: leave everything in its normal (stacked) state
        if (!enabled || texts.length < 2) return;

        col.classList.add('is-rotating');
        texts[0].classList.add('is-active');

        var rotator = { col: col, texts: texts, idx: 0, timer: null, paused: false };
        rotator.timer = setInterval(function () {
          if (rotator.paused) return;
          rotator.texts[rotator.idx].classList.remove('is-active');
          rotator.idx = (rotator.idx + 1) % rotator.texts.length;
          rotator.texts[rotator.idx].classList.add('is-active');
        }, interval);

        topbar.__rotators.push(rotator);
      });
    }

    function setupAll(scope) {
      (scope || document).querySelectorAll('.topbar').forEach(setup);
    }

    // Theme editor: when a text block is selected, freeze on it so it stays visible
    function showSelected(target) {
      if (!target || !target.closest) return;
      var text = target.closest('.topbar__text');
      if (!text) return;
      var col = text.closest('.topbar__column');
      var topbar = text.closest('.topbar');
      if (!topbar || !topbar.__rotators) return;
      topbar.__rotators.forEach(function (r) {
        if (r.col !== col) return;
        r.paused = true;
        r.texts.forEach(function (t) { t.classList.remove('is-active'); });
        text.classList.add('is-active');
        r.idx = r.texts.indexOf(text);
      });
    }

    function resume(topbar) {
      if (topbar && topbar.__rotators) {
        topbar.__rotators.forEach(function (r) { r.paused = false; });
      }
    }

    if (document.readyState !== 'loading') {
      setupAll();
    } else {
      document.addEventListener('DOMContentLoaded', function () { setupAll(); });
    }

    document.addEventListener('shopify:section:load', function (e) { setupAll(e.target); });
    document.addEventListener('shopify:section:unload', function (e) {
      e.target.querySelectorAll('.topbar').forEach(function (tb) {
        (tb.__rotators || []).forEach(function (r) { clearInterval(r.timer); });
      });
    });
    document.addEventListener('shopify:block:select', function (e) { showSelected(e.target); });
    document.addEventListener('shopify:block:deselect', function (e) {
      var topbar = e.target.closest && e.target.closest('.topbar');
      resume(topbar);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
